/* =============================================
   REVERIE ARTWEAR — Main JS
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // ── SIZE SELECTOR ─────────────────────────
  document.querySelectorAll('.rv-sizes').forEach(group => {
    group.querySelectorAll('.rv-size').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        // Deactivate siblings
        group.querySelectorAll('.rv-size').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        // Update hidden variant input in parent form
        const form = group.closest('form');
        if (form) {
          const input = form.querySelector('.rv-variant-id');
          if (input && btn.dataset.variantId) {
            input.value = btn.dataset.variantId;
          }
        }
      });
    });
  });

  // ── ADD TO CART ───────────────────────────
  document.querySelectorAll('.rv-product-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      const formData = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: 1
          })
        });
        if (res.ok) {
          btn.textContent = 'Added!';
          updateCartCount();
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1800);
        } else {
          btn.textContent = 'Try again';
          btn.disabled = false;
        }
      } catch {
        btn.textContent = 'Error';
        btn.disabled = false;
      }
    });
  });

  // ── CART COUNT ────────────────────────────
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.rv-cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch {}
  }
  updateCartCount();

  // ── COUNTDOWN ─────────────────────────────
  const countdownEl = document.querySelector('.rv-countdown[data-target]');
  if (countdownEl) {
    const target = new Date(countdownEl.dataset.target);
    const dEl = document.getElementById('cd-d');
    const hEl = document.getElementById('cd-h');
    const mEl = document.getElementById('cd-m');
    const sEl = document.getElementById('cd-s');

    function tick() {
      let diff = Math.max(0, target - new Date()) / 1000;
      const d = Math.floor(diff / 86400); diff -= d * 86400;
      const h = Math.floor(diff / 3600); diff -= h * 3600;
      const m = Math.floor(diff / 60);
      const s = Math.floor(diff - m * 60);
      if (dEl) dEl.textContent = String(d).padStart(2, '0');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  }

  // ── EMAIL SIGNUP FEEDBACK ─────────────────
  const emailForm = document.getElementById('email-signup-form');
  if (emailForm) {
    emailForm.addEventListener('submit', () => {
      const btn = emailForm.querySelector('.rv-esubmit');
      if (btn) {
        btn.textContent = '✓ Subscribed';
        btn.style.background = '#3A6B2A';
      }
    });
  }

});

/* =============================================
   PRODUCT QUICK-VIEW MODALS
   ============================================= */

// Open modal by ID
function openModal(id) {
  const modal = document.getElementById('modal-' + id);
  if (modal) {
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
}

// Close modal by ID
function closeModal(id) {
  const modal = document.getElementById('modal-' + id);
  if (modal) {
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {

  // ── CARD CLICK → OPEN MODAL ──────────────
  document.querySelectorAll('[data-open-modal]').forEach(card => {
    card.addEventListener('click', () => {
      const modalId = card.dataset.openModal;
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
    });
    // Keyboard accessibility
    card.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        card.click();
      }
    });
  });

  // ── CLOSE BUTTONS ─────────────────────────
  document.querySelectorAll('[data-modal-close]').forEach(btn => {
    btn.addEventListener('click', () => {
      const modal = document.getElementById(btn.dataset.modalClose);
      if (modal) {
        modal.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
  });

  // ── CLOSE ON OVERLAY CLICK ────────────────
  document.querySelectorAll('.modal-overlay').forEach(overlay => {
    overlay.addEventListener('click', e => {
      if (e.target === overlay) {
        overlay.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
  });

  // ── CLOSE ON ESCAPE ───────────────────────
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal-overlay.open').forEach(m => {
        m.classList.remove('open');
        document.body.style.overflow = '';
      });
    }
  });

  // ── SIZE SELECTOR IN MODALS ───────────────
  function attachSizeHandlers() {
    document.querySelectorAll('.modal-size, .rv-sz-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        const group = btn.dataset.group;
        document.querySelectorAll(`[data-group="${group}"]`).forEach(b => {
          b.classList.remove('active');
          b.style.outline = 'none';
        });
        btn.classList.add('active');
        btn.style.outline = '2.5px solid #f5f0e8';
        btn.style.outlineOffset = '2px';
        // Update hidden variant input in parent form
        const form = btn.closest('form');
        if (form) {
          const input = form.querySelector('.modal-variant-id');
          if (input && btn.dataset.variantId) {
            input.value = btn.dataset.variantId;
          }
        }
      });
    });
  }
  attachSizeHandlers();

  // ── SIZE CHART TOGGLE ─────────────────────
  document.querySelectorAll('[data-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = document.getElementById(btn.dataset.toggle);
      if (!target) return;
      const isHidden = target.style.display === 'none' || target.style.display === '';
      target.style.display = isHidden ? 'block' : 'none';
      btn.textContent = isHidden ? '▴ Hide size chart' : '▾ View size chart';
    });
  });

  // ── BUNDLE DUAL SIZE HANDLER ─────────────
  document.querySelectorAll('[data-tank-variant],[data-shorts-variant]').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.dataset.group;
      document.querySelectorAll(`[data-group="${group}"]`).forEach(b => {
        b.style.outline = 'none';
      });
      btn.style.outline = '2.5px solid #f5f0e8';
      btn.style.outlineOffset = '2px';
    });
  });

  // ── SEARCH BUTTON ─────────────────────────
  document.querySelectorAll('.rv-icon-btn[aria-label="Search"], [data-open-search]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      window.location.href = '/search';
    });
  });

  // ── MODAL ADD TO CART ─────────────────────
  document.querySelectorAll('.modal-product-form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('.modal-add');
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      // Bundle: add tank + shorts separately with chosen sizes
      const isBundleForm = form.querySelector('[data-tank-variant]') !== null;
      if (isBundleForm) {
        const tankBtn   = form.querySelector('[data-tank-variant][style*="2.5px"]');
        const shortsBtn = form.querySelector('[data-shorts-variant][style*="2.5px"]');
        if (!tankBtn || !shortsBtn) {
          if (btn) { btn.textContent = 'Select a size for each piece'; btn.disabled = false; }
          return;
        }
        try {
          await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: tankBtn.dataset.tankVariant, quantity: 1 }) });
          await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: shortsBtn.dataset.shortsVariant, quantity: 1 }) });
          if (btn) btn.textContent = '✓ Bundle Added!';
          setTimeout(() => {
            document.querySelectorAll('.modal-overlay.open').forEach(m => m.classList.remove('open'));
            document.body.style.overflow = '';
            if (typeof openDrawer === 'function') openDrawer();
            if (btn) { btn.textContent = originalText; btn.disabled = false; }
          }, 600);
        } catch { if (btn) { btn.textContent = 'Error'; btn.disabled = false; } }
        return;
      }

      const variantInput = form.querySelector('.modal-variant-id');
      if (!variantInput || !variantInput.value) {
        if (btn) { btn.textContent = 'Select a size'; btn.disabled = false; }
        return;
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantInput.value, quantity: 1 })
        });

        if (res.ok) {
          if (btn) btn.textContent = '✓ Added!';
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          document.querySelectorAll('.rv-cart-badge').forEach(el => {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
          setTimeout(() => {
            document.querySelectorAll('.modal-overlay.open').forEach(m => {
              m.classList.remove('open');
            });
            document.body.style.overflow = '';
            if (typeof openDrawer === 'function') openDrawer();
            if (btn) { btn.textContent = originalText; btn.disabled = false; }
          }, 800);
        } else {
          if (btn) { btn.textContent = 'Try again'; btn.disabled = false; }
        }
      } catch {
        if (btn) { btn.textContent = 'Error'; btn.disabled = false; }
      }
    });
  });

});

/* =============================================
   MOBILE NAV
   ============================================= */
(function() {
  const hamburger = document.querySelector('.rv-hamburger');
  const mobileNav = document.querySelector('.rv-mobile-nav');
  const mobileClose = document.querySelector('.rv-mobile-nav-close');

  function openMobileNav() {
    if (!mobileNav) return;
    hamburger && hamburger.classList.add('open');
    mobileNav.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    hamburger && hamburger.classList.remove('open');
    mobileNav.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMobileNav);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
  document.querySelectorAll('.rv-mobile-nav a').forEach(a => {
    a.addEventListener('click', closeMobileNav);
  });
})();

/* =============================================
   EMAIL POPUP — shows after 8s, once per session
   ============================================= */
(function() {
  if (sessionStorage.getItem('rv-popup-seen')) return;
  const overlay = document.getElementById('rv-popup-overlay');
  if (!overlay) return;

  function closePopup() {
    overlay.classList.remove('open');
    sessionStorage.setItem('rv-popup-seen', '1');
  }

  setTimeout(function() {
    overlay.classList.add('open');
  }, 8000);

  const closeBtn = overlay.querySelector('.rv-popup-close');
  const dismissBtn = overlay.querySelector('.rv-popup-dismiss');
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (dismissBtn) dismissBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closePopup();
  });

  const form = overlay.querySelector('form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]').value.trim();
      if (!email) return;
      fetch('/contact', {
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: new URLSearchParams(new FormData(form))
      }).finally(function() {
        overlay.querySelector('.rv-popup-body').innerHTML =
          '<p class="rv-popup-eyebrow">✦ You\'re on the list</p>' +
          '<p class="rv-popup-title"><em>See you</em> at drop.</p>' +
          '<p class="rv-popup-sub" style="margin-bottom:0;">We\'ll be in touch before the Flowers Show Life SS26 drop.</p>';
        setTimeout(closePopup, 2800);
      });
    });
  }
})();

/* =============================================
   COOKIE BANNER
   ============================================= */
(function() {
  if (localStorage.getItem('rv-cookies')) return;
  const banner = document.getElementById('rv-cookie-banner');
  if (!banner) return;

  setTimeout(function() { banner.classList.add('show'); }, 1200);

  const accept = banner.querySelector('.rv-cookie-accept');
  const decline = banner.querySelector('.rv-cookie-decline');

  function dismiss(accepted) {
    banner.classList.remove('show');
    localStorage.setItem('rv-cookies', accepted ? 'accepted' : 'declined');
  }
  if (accept) accept.addEventListener('click', function() { dismiss(true); });
  if (decline) decline.addEventListener('click', function() { dismiss(false); });
})();

/* =============================================
   ACCORDION TABS
   ============================================= */
document.querySelectorAll('.rv-accordion-trigger').forEach(function(btn) {
  btn.addEventListener('click', function() {
    const item = btn.closest('.rv-accordion-item');
    const isOpen = item.classList.contains('open');
    // Close all
    document.querySelectorAll('.rv-accordion-item.open').forEach(function(i) {
      i.classList.remove('open');
    });
    // Open this one if it wasn't open
    if (!isOpen) item.classList.add('open');
  });
});

/* =============================================
   QUANTITY SELECTOR
   ============================================= */
document.querySelectorAll('.rv-qty').forEach(function(qty) {
  const val = qty.querySelector('.rv-qty-val');
  const minus = qty.querySelector('[data-qty-minus]');
  const plus  = qty.querySelector('[data-qty-plus]');
  if (!val) return;
  let count = parseInt(val.textContent) || 1;

  if (minus) minus.addEventListener('click', function() {
    if (count > 1) { count--; val.textContent = count; }
    const inp = qty.querySelector('input[name="quantity"]');
    if (inp) inp.value = count;
  });
  if (plus) plus.addEventListener('click', function() {
    count++; val.textContent = count;
    const inp = qty.querySelector('input[name="quantity"]');
    if (inp) inp.value = count;
  });
});

/* =============================================
   QUICK ADD (collection cards)
   ============================================= */
document.querySelectorAll('.rv-quick-sz').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.stopPropagation();
    const card = btn.closest('.rv-card');
    card.querySelectorAll('.rv-quick-sz').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
  });
});

document.querySelectorAll('.rv-quick-add-btn').forEach(function(btn) {
  btn.addEventListener('click', async function(e) {
    e.stopPropagation();
    const card = btn.closest('.rv-card');
    const activeSize = card.querySelector('.rv-quick-sz.active');
    const variantId = activeSize ? activeSize.dataset.variantId : btn.dataset.variantId;
    if (!variantId) {
      btn.textContent = 'Pick a size';
      setTimeout(function() { btn.textContent = 'Add'; }, 1600);
      return;
    }
    const orig = btn.textContent;
    btn.textContent = '...';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: variantId, quantity: 1})
      });
      if (res.ok) {
        btn.textContent = '✓';
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.querySelectorAll('.rv-cart-badge').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        setTimeout(function() { btn.textContent = orig; }, 1400);
      } else {
        btn.textContent = 'Error';
        setTimeout(function() { btn.textContent = orig; }, 1400);
      }
    } catch(err) {
      btn.textContent = orig;
    }
  });
});

/* =============================================
   PROMO CODE
   ============================================= */
(function() {
  const applyBtn = document.querySelector('.rv-promo-apply');
  if (!applyBtn) return;
  applyBtn.addEventListener('click', async function() {
    const input = document.querySelector('.rv-promo-input');
    if (!input || !input.value.trim()) return;
    const code = input.value.trim().toUpperCase();
    const orig = applyBtn.textContent;
    applyBtn.textContent = '...';
    try {
      const res = await fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        headers: {'X-Requested-With': 'XMLHttpRequest'}
      });
      applyBtn.textContent = res.ok ? '✓ Applied' : 'Invalid';
      if (!res.ok) {
        input.style.borderColor = 'rgba(193,78,40,0.6)';
        setTimeout(function() {
          applyBtn.textContent = orig;
          input.style.borderColor = '';
        }, 2000);
      }
    } catch(err) {
      applyBtn.textContent = orig;
    }
  });
})();
